/**
 * formatDuration — localised time-remaining / elapsed label
 * Returns short human-readable string for prayer countdown/elapsed
 *
 * @param {number} diffMin   — positive = remaining, negative = elapsed
 * @param {string} language  — 'en'|'ar'|'fr'|'es'|'ur'
 * @param {boolean} elapsed  — true when showing time-since (ago)
 */

const toAr = (n) => String(n).replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);

export const formatDuration = (diffMinRaw, language = 'en', elapsed = false) => {
  const abs = Math.abs(diffMinRaw || 0);
  if (abs === 0) return language === 'ar' ? 'الآن' : language === 'ur' ? 'ابھی' : language === 'fr' ? 'maintenant' : language === 'es' ? 'ahora' : 'now';

  const h = Math.floor(abs / 60);
  const m = abs % 60;

  if (language === 'ar') {
    const hAr = toAr(h);
    const mAr = toAr(m);
    const prefix = elapsed ? 'منذ ' : 'بعد ';

    if (h > 0 && m > 0) return `${prefix}${hAr}س ${mAr}د`;
    if (h === 1) return `${prefix}ساعة`;
    if (h === 2) return `${prefix}ساعتين`;
    if (h > 2 && h < 11) return `${prefix}${hAr} ساعات`;
    if (h >= 11) return `${prefix}${hAr} ساعة`;
    if (m === 1) return `${prefix}دقيقة`;
    if (m === 2) return `${prefix}دقيقتين`;
    if (m > 2 && m < 11) return `${prefix}${mAr} دقائق`;
    return `${prefix}${mAr} دقيقة`;
  }

  if (language === 'ur') {
    const prefix = elapsed ? 'پہلے ' : 'میں ';
    if (h > 0 && m > 0) return `${h}گھ ${m}م ${prefix}`;
    if (h > 0) return `${h}گھ ${prefix}`;
    return `${m}م ${prefix}`;
  }

  if (language === 'fr') {
    const prefix = elapsed ? 'il y a ' : 'dans ';
    if (h > 0 && m > 0) return `${prefix}${h}h ${m}m`;
    if (h > 0) return `${prefix}${h}h`;
    return `${prefix}${m}m`;
  }

  if (language === 'es') {
    const prefix = elapsed ? 'hace ' : 'en ';
    if (h > 0 && m > 0) return `${prefix}${h}h ${m}m`;
    if (h > 0) return `${prefix}${h}h`;
    return `${prefix}${m}m`;
  }

  // Default English
  const prefix = elapsed ? '' : '';
  if (h > 0 && m > 0) return `${h}h ${m}m`;
  if (h > 0) return `${h}h`;
  return `${m}m`;
};

/** Format a verse key in current locale numerals */
export const localizeVerseKey = (verseKey, language) => {
  if (language !== 'ar' && language !== 'ur') return verseKey;
  return verseKey.replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
};
